module.exports = __webpack_public_path__ + "img/twitter.4021904f.jpg";